import React from "react";

const QuantitySelector = ({
  value,
  onChange,
  min = 0,
  max = 100,
  className = "",
  style = {},
  width = "38px",
  height = "38px",
}) => {
  const handleDecrease = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div
      className={`d-flex align-items-center bg-white p-2 rounded-3 border shadow-sm justify-content-between ${className}`}
      style={{ ...style }}
    >
      <button
        className="btn btn-light rounded-circle border d-flex align-items-center justify-content-center text-primary"
        style={{ width, height }}
        onClick={handleDecrease}
        type="button"
        disabled={value <= min}
      >
        <i className="fs-5 fw-bold">-</i>
      </button>
      <span
        className="fw-bold fs-4 text-dark"
        style={{ minWidth: "40px", textAlign: "center" }}
      >
        {value}
      </span>
      <button
        className="btn btn-light rounded-circle border d-flex align-items-center justify-content-center text-primary"
        style={{ width, height }}
        onClick={handleIncrease}
        type="button"
        disabled={value >= max}
      >
        <i className="fs-5 fw-bold">+</i>
      </button>
    </div>
  );
};

export default QuantitySelector;
